import { CButtonClassname, EButtonColor, ESectionAlign, ESectionColor, Section } from '@web_opxp/components';
import { NextObStepLink, OnboardingFlowProgress, useTranslation } from '@web_opxp/features';
import React from 'react';
import { AssetsBaseUrl } from '../base/env';
import './MascotSection.scss';

export interface IMascotSectionViewProps {
  onTopButtonHandler: React.MouseEventHandler<HTMLAnchorElement>;
}

const MascotSection = () => {
  const imageSrc = `${AssetsBaseUrl}/lp/lp-mascot-blackboard2.png`;
  const { t } = useTranslation();
  const introText = t('Welcome.Mascot.Intro');
  let introFontSize = ' large';

  if (introText.length > 200) {
    introFontSize = ' small';
  } else if (introText.length > 125) {
    introFontSize = ' medium';
  }

  return (
    <>
      <Section color={ESectionColor.blue} align={ESectionAlign.center} className="mascot-section">
        <div className="content-wrapper row">
          <NextObStepLink className="image-link-wrapper" currentStepName="welcome">
            <div className="img-wrapper">
              <div className="col-12 content">
                <img src={imageSrc} alt="mascot-brainstein" />
                <p className={`mascot-intro${introFontSize}`}>{introText}</p>
              </div>
            </div>
          </NextObStepLink>
          <div className="button-wrapper">
            <NextObStepLink className={`${CButtonClassname} ${EButtonColor.blue}`} currentStepName="welcome">
              {t('common.common:Header.Menu.Start')}
            </NextObStepLink>
          </div>
        </div>
      </Section>
      <Section>
        <OnboardingFlowProgress currentStep="welcome" />
      </Section>
    </>
  );
};

export default MascotSection;
